import { FileExtension } from '__generated__/globalTypes'

export function strToFileExtension(str: string): FileExtension | false {
  if (str === 'image/jpg') return FileExtension.JPG
  if (str === 'image/jpeg') return FileExtension.JPEG
  if (str === 'image/png') return FileExtension.PNG
  if (str === 'video/mp4') return FileExtension.MP4
  return false
}
